import React,{Component} from 'react'

import Button from 'react-bootstrap/lib/Button';

import constants from '../../util/constants'

class FrappButton extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            isLoading:false,
            showLoadingMessage:false
        }
    }
    
    render(){
        const loadingMessages = constants.loadingMessages;
        return (
            <Button 
                id={this.props.id}
                type={this.props.type}
                bsStyle={this.props.bsStyle}
                disabled={this.state.isLoading || this.props.disabled}
                title={this.props.title}
                onClick={!this.state.isLoading ? this.props.handler:null} 
                className={'frapp-btn '+this.props.className}
                {...this.getDataProps()}
            >{this.state.isLoading ? (loadingMessages[this.props.children] ? loadingMessages[this.props.children] : !loadingMessages[this.props.className] ? this.props.children : loadingMessages[this.props.className]): this.props.children}</Button>
        )
    }
    
    getDataProps = () => {
        let propKeys = Object.keys(this.props);
        let dataProps = {};
        
        for(let key of propKeys){
            if(key.indexOf('data') >= 0){
                dataProps[key] = this.props[key]
            }
        }
        
        return dataProps;
    }

    startLoading = () => {
        this.setState({isLoading:true})
    }
    
    stopLoading = () => {
        this.setState({isLoading:false})
    }
}

export default FrappButton
